import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Segment,
  Header,
  Checkbox,
  Button,
  Message,
  Divider,
  Icon,
} from 'semantic-ui-react';
import { YONERGE } from '../../constants/qtestTexts';

// data: [{ question: "Sayfa N", options: [{ id, text }, …] }, …] — sunucudan gelen sırayla
const Quiz = ({ data, endQuiz, userInfo }) => {
  const [questionIndex, setQuestionIndex] = useState(0);
  // Sayfa başına seçilen ifade kimlikleri; geri dönüldüğünde seçimler korunur
  const [selections, setSelections] = useState(() => data.map(() => []));

  const currentQuestion = data[questionIndex];
  const selectedIds = selections[questionIndex] || [];
  const options = currentQuestion?.options || [];
  const isLast = questionIndex === data.length - 1;

  useEffect(() => {
    if (questionIndex > 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [questionIndex]);

  const toggleOption = (option) => {
    setSelections((prev) => {
      const next = [...prev];
      const current = next[questionIndex] || [];
      next[questionIndex] = current.includes(option.id)
        ? current.filter((id) => id !== option.id)
        : [...current, option.id];
      return next;
    });
  };

  const handleBack = () => {
    if (questionIndex > 0) {
      setQuestionIndex(questionIndex - 1);
    }
  };

  const handleNext = () => {
    if (!isLast) {
      setQuestionIndex(questionIndex + 1);
      return;
    }

    const questionsAndAnswers = data.map((q, i) => {
      const ids = selections[i] || [];
      return {
        question: q.question,
        selectedOptionIds: ids,
        selectedTexts: q.options.filter((o) => ids.includes(o.id)).map((o) => o.text),
      };
    });
    endQuiz({
      totalQuestions: data.length,
      questionsAndAnswers,
    });
  };

  return (
    <Container>
      <Segment padded>
        <Header as="h2" textAlign="center">
          Sayfa {questionIndex + 1} / {data.length}
        </Header>
        <Message floating size="large" icon>
  <Icon name="question circle outline" />
  <Message.Content>
  <Message.List>
    <Message.Item><strong>İsim:</strong> {userInfo.full_name}</Message.Item>
    <Message.Item><strong>Email:</strong> {userInfo.email}</Message.Item>
  </Message.List>

  <Divider />

  <div style={{
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#555',
    padding: '0.5rem 1rem',
    maxWidth: '100%',
    wordBreak: 'break-word',
  }}>
    <p>{YONERGE}</p>
  </div>
</Message.Content>

</Message>


        <Divider />

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {options.map((option) => (
            <Checkbox
              key={option.id}
              label={
                <label style={{ fontWeight: 'bold', cursor: 'pointer' }}>
                  {option.text}
                </label>
              }
              checked={selectedIds.includes(option.id)}
              onChange={() => toggleOption(option)}
            />
          ))}
        </div>

        <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
          {questionIndex > 0 && (
            <Button size="large" onClick={handleBack} style={{ flex: 1 }}>
              <Icon name="arrow left" /> Geri
            </Button>
          )}
          <Button
            primary
            size="large"
            disabled={selectedIds.length === 0}
            onClick={handleNext}
            style={{ flex: 2 }}
          >
            {isLast ? 'Bitir' : 'İleri'}
          </Button>
        </div>
      </Segment>
    </Container>
  );
};

Quiz.propTypes = {
  data: PropTypes.array.isRequired,
  endQuiz: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
};

export default Quiz;
